import _ from 'lodash'
import localizeFilter from '@/filters/localize.filter'
export default {
    data () {
        return {
            page: +this.$route.query.page || 1,
            pageSize: 5,
            pageCount: 0,
            allItems: [],
            itmes: [],
            prev: '',
            next: ''
        }
    },
    mounted() {
        this.prev = localizeFilter('Prev')
        this.next = localizeFilter('Next')
    },
    methods: {
        pageChangeHandler(page){
            this.$router.push(`${this.$route.path}?page=${page}`)
            this.items = this.allItems[page - 1] || this.allItems[0]
        },
        setupPagination(allItems) {
            this.allItems = _.chunk(allItems, this.pageSize)
            this.pageCount = _.size(this.allItems)
            this.items = this.allItems[this.page - 1] || this.allItems[0]
        }
    }
}